export default {
  state: {
    isMenuOpen: false,
  },
  mutations: {
    changeMenuStatus(state, status) {
      state.isMenuOpen = status
    },
  },
  getters: {
    isMenuOpen: state => {
      return state.isMenuOpen
    },
  }
}